<div class="card-container" [ngClass]="{ 'card-highlighted': isHighlighted, 'card-radio-select': isRadioSelect }" (click)="handleClick()">
  <ng-content></ng-content>
</div>
